// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__KU49I","footer":"ModalFilter_footer__2-3Wv"};